import React, { useEffect, useRef, useState } from "react";
import { headerStyle } from "../css/styles/componentStyles";
import { allHeaderTab, navTabs } from "../utils/string";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ReplyIcon from "@mui/icons-material/Reply";
import { ArrowBack } from "@mui/icons-material";
function Header({
  selectedTab,
  setSelectedTab,
  selectedMonthTab,
  setSelectedMonthTab,
  pageViewHandler,
}) {
  const [months, setMonths] = useState([]);
  const monthsScrollRef = useRef(null);

  const generateMonths = () => {
    const currentDate = new Date();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const fullMonthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const generatedMonths = [];

    for (let i = 0; i < 12 * 5; i++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1,
      );
      const shortMonth = monthNames[date.getMonth()];
      const year = date.getFullYear().toString();
      const monthValue = `${fullMonthNames[date.getMonth()]} ${year}`;

      generatedMonths.push({ month: shortMonth, year, monthValue });
    }

    setMonths(generatedMonths.reverse());
  };
  useEffect(() => {
    generateMonths();
  }, []);
  useEffect(() => {
    if (monthsScrollRef.current && months.length > 0) {
      setTimeout(() => {
        if (monthsScrollRef.current) {
          monthsScrollRef.current.scrollLeft =
            monthsScrollRef.current.scrollWidth;
        }
      }, 100);
    }
  }, [months]);

  const handleBack = (e) => {
    console.log("pageViewHandler",pageViewHandler);
    pageViewHandler(e, "landingPage");
  };

  const selectedMonthTabHandler = (item) => {
    if (item.monthValue === selectedMonthTab.monthValue) {
      setSelectedMonthTab({});
    } else {
      setSelectedMonthTab(item);
    }
  };

  return (
    <div
      className="shadow"
      style={{
        ...headerStyle.headerContainer,
        padding: "10px",
        color: "#fff",
        position: "fixed",
        top: "71px",
        width: "100%",
        zIndex: 999,
        boxShadow: "3px 5px 10px 0 #eee",
        margin: 0,
        left: 0,
        right: 0,
      }}
    >
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "2px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginBottom: "0",
              alignItems: "center",
            }}
          >
            <div>
              <ReplyIcon
                style={{
                  fontSize: "30px",
                  marginRight: "20px",
                  cursor: "pointer",
                }}
                onClick={(e) => handleBack(e)}
              />
            </div>
            {navTabs.map((tab) => (
              // Comment out the Transactions tab as requested
              tab.id !== 'transactions' && (
              <button
                key={tab.id}
                className={`btn `}
                onClick={() => setSelectedTab(tab.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "16px",
                  padding: "8px 16px",
                  border:
                    selectedTab === tab.id
                      ? "2px solid #ffc107"
                      : "1px solid transparent",
                  color: selectedTab === tab.id ? "#ffc107" : "#fff",
                  backgroundColor:
                    selectedTab === tab.id
                      ? "rgba(255, 193, 7, 0.1)"
                      : "transparent",
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  boxShadow:
                    selectedTab === tab.id
                      ? "0 4px 8px rgba(255, 193, 7, 0.3)"
                      : "none",
                }}
                onMouseEnter={(e) => {
                  if (selectedTab !== tab.id) {
                    e.currentTarget.style.border = "2px solid #ffc107";
                    e.currentTarget.style.color = "#ffc107";
                    e.currentTarget.style.backgroundColor =
                      "rgba(255, 193, 7, 0.1)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(255, 193, 7, 0.3)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedTab !== tab.id) {
                    e.currentTarget.style.border = "1px solid transparent";
                    e.currentTarget.style.color = "#fff";
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
              >
                <span style={{ marginRight: "8px" }}>
                  {tab.icon === "grid" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <rect x="3" y="3" width="7" height="7" rx="1" />
                      <rect x="14" y="3" width="7" height="7" rx="1" />
                      <rect x="3" y="14" width="7" height="7" rx="1" />
                      <rect x="14" y="14" width="7" height="7" rx="1" />
                    </svg>
                  )}
                  {tab.icon === "file-text" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14,2 14,8 20,8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                      <polyline points="10,9 9,9 8,9" />
                    </svg>
                  )}
                  {tab.icon === "calendar" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                  )}
                  {tab.icon === "edit" && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                    </svg>
                  )}
                </span>
                {tab.label}
              </button>
              )
            ))}
          </div>

          <div
            ref={monthsScrollRef}
            style={{
              display: "flex",
              flexWrap: "nowrap",
              justifyContent: "flex-start",
              alignItems: "center",
              overflowX: "auto",
              maxWidth: "400px",
              paddingBottom: "12px",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(255, 193, 7, 0.5) transparent",
              WebkitScrollbar: {
                height: "4px",
              },
              position: "relative",
              background:
                "linear-gradient(90deg, rgba(0,0,0,0.1) 0%, transparent 20%, transparent 80%, rgba(0,0,0,0.1) 100%)",
              borderRadius: "12px",
              padding: "8px 12px",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              boxShadow:
                "inset 0 2px 4px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.1)",
            }}
          >
            {months.map((item, index) => {
              const isSelected =
                selectedMonthTab.month === item.month &&
                selectedMonthTab.year === item.year;
              return (
                <div
                  key={index}
                  style={{
                    cursor: "pointer",
                    textAlign: "center",
                    margin: "0 6px",
                    flexDirection: "column",
                    alignItems: "center",
                    minWidth: "50px",
                    flexShrink: 0,
                    padding: "8px 12px",
                    borderRadius: "10px",
                    background: isSelected
                      ? "linear-gradient(135deg, #ffc107 0%, #ffb300 100%)"
                      : "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                    border: isSelected
                      ? "2px solid #ffc107"
                      : "1px solid rgba(255,255,255,0.1)",
                    transform: isSelected ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: isSelected
                      ? "0 4px 12px rgba(255, 193, 7, 0.3), 0 2px 4px rgba(0,0,0,0.1)"
                      : "none",
                    backdropFilter: "blur(8px)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onClick={() => selectedMonthTabHandler(item)}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 193, 7, 0.05) 100%)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(255, 193, 7, 0.3)";
                      e.currentTarget.style.border = "2px solid #ffc107";
                      e.currentTarget.querySelector(
                        "div:first-of-type",
                      ).style.color = "#ffc107";
                      e.currentTarget.querySelector(
                        "div:last-of-type",
                      ).style.color = "#ffc107";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.border =
                        "1px solid rgba(255,255,255,0.1)";
                      e.currentTarget.querySelector(
                        "div:first-of-type",
                      ).style.color = "#fff";
                      e.currentTarget.querySelector(
                        "div:last-of-type",
                      ).style.color = "rgba(255,255,255,0.9)";
                    }
                  }}
                >
                  {isSelected && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "-100%",
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                        animation: "shimmer 2s infinite",
                        "@keyframes shimmer": {
                          "0%": { left: "-100%" },
                          "100%": { left: "100%" },
                        },
                      }}
                    />
                  )}

                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: isSelected ? "700" : "500",
                      marginBottom: "2px",
                      color: isSelected ? "#000" : "#fff",
                      textShadow: isSelected
                        ? "none"
                        : "0 1px 2px rgba(0,0,0,0.3)",
                      letterSpacing: "0.5px",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {item.month}
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: isSelected ? "600" : "400",
                      color: isSelected ? "#000" : "rgba(255,255,255,0.9)",
                      textShadow: isSelected
                        ? "none"
                        : "0 1px 2px rgba(0,0,0,0.3)",
                      letterSpacing: "0.3px",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {item.year}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
